import { createSlice } from '@reduxjs/toolkit';

import { VALID_PAYLATER_ORDER_STATUSES } from '../../utils/constants';

import type { PayLaterState } from './payLaterSlice.d';

const initialState: PayLaterState = {
  fetchPosUuidsPending: false,
  posUuidsByIU: {},
  storeUuids: [],
  paylaterFilterReadyFirstTime: false,
  fetchPaylaterOrderPending: true,
  paylaterOrderRefundPending: false,
  activeFilterParams: {
    iuSelect: '',
    search: '',
    startDate: '',
    endDate: '',
    storesUuids: [],
    posUuids: [],
    pageIndex: 1,
    pageSize: 10,
    sortOrder: 'desc',
    isAllPosUuids: true,
    orderStatuses: VALID_PAYLATER_ORDER_STATUSES,
  },
  paylaterOrderRefundStatus: { status: '', requestId: '', type: '', code: '', message: '' },
  payLaterOrderList: [],
  totalCount: 0,
  totalOrderAmount: 0,
  totalOrders: 0,
  hasPaylaterOutlet: true,
  downloadPending: false,
};

export const payLaterSlice = createSlice({
  name: 'payLater',
  initialState,
  reducers: {
    setActiveFilterParams: (state, action) => {
      state.activeFilterParams = action.payload;
    },
    setFetchPaylaterOrderPending: (state, action) => {
      state.fetchPaylaterOrderPending = action.payload;
    },
    setHasPaylaterOutlet: (state, action) => {
      state.hasPaylaterOutlet = action.payload;
    },
    setPaylaterFilterReadyFirstTime: (state, action) => {
      state.paylaterFilterReadyFirstTime = action.payload;
    },
  },
});

export default payLaterSlice.reducer;
